import { LoginPage } from '@practium/features/auth';
import { useAppNavigation } from '@practium/features/navigation';

export const LoginPageAdmin = () => {
	const { navigateToAdminHome } = useAppNavigation();

	return <LoginPage onSuccess={navigateToAdminHome} />;
};
